// PDF React View
import { yupResolver } from "@hookform/resolvers/yup";
import {
  generateInputField,
  generateSelectField,
} from "helpers/form_helper_old";
import { FIELD_CUSTOMER, LIST_TYPE_ID } from "pages/GeneralInfo/Customer/utils";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import * as yup from "yup";
const SearchCustomerModal = props => {
  const { isOpen, toggle, getInfoCustomerHandle, setValueFunc, mapData } =
    props;

  const dispatch = useDispatch();
  const { t } = useTranslation(["customer"]);

  const customerInvoice = useSelector(state => state.customerInvoice);
  const { listAllCustomer, loadListAllCustomer } = customerInvoice;

  useEffect(() => {
    // dispatch(getAllCustomerInvoice(getValues("type_id").value));
  }, []);

  useEffect(() => {
    if (isOpen) {
    }
  }, [isOpen]);

  const schema = yup.object().shape({
    customer: yup.object().nullable(),
    type_id: yup
      .object()
      .required(t("form.validate.select", { title: t("form.type_id") })),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    watch,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: { customer: undefined, type_id: LIST_TYPE_ID[0] },
  });

  const submitForm = submitData => {
    toggle();
    if (setValueFunc) {
      for (const item in mapData) {
        if (item === FIELD_CUSTOMER.STKNHANG || item === FIELD_CUSTOMER.MA) {
          setValueFunc(
            mapData[item],
            {
              value: getValues(item),
              label: getValues(item),
            } || null,
            {
              shouldValidate: true,
            }
          );
        } else {
          setValueFunc(mapData[item], getValues(item) || "", {
            shouldValidate: true,
          });
        }
      }
    }
    getInfoCustomerHandle && getInfoCustomerHandle(submitData.customer);
  };

  const loadDataCustomer = dataDetail => {
    if (dataDetail) {
      setValue("ma", dataDetail.ma);
      setValue("ten", dataDetail.ten);
      setValue("idno", dataDetail.idno);
      setValue("mst", dataDetail.mst);
      setValue("cty", dataDetail.cty);
      setValue("stknhang", dataDetail.stknhang);
      setValue("tnhang", dataDetail.tnhang);
      setValue("dchi", dataDetail.dchi);
      setValue("sdthoai", dataDetail.sdthoai);
      setValue("dctdtu", dataDetail.dctdtu);
      setValue("fax", dataDetail.fax);
    } else {
      setValue("ma", "");
      setValue("ten", "");
      setValue("idno", "");
      setValue("mst", "");
      setValue("cty", "");
      setValue("stknhang", "");
      setValue("tnhang", "");
      setValue("dchi", "");
      setValue("sdthoai", "");
      setValue("dctdtu", "");
      setValue("fax", "");
    }
  };

  return (
    <Modal
      size="xl"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      // style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>Tìm kiếm khách hàng</Label>
        </ModalHeader>
        <ModalBody>
          <Row className="row-cols-1 row-cols-lg-2">
            <Col>
              <FormGroup className="mb-3">
                {generateSelectField(
                  "Khách hàng",
                  false,
                  errors,
                  "customer",
                  "Vui lòng tìm khách hàng",
                  false,
                  control,
                  listAllCustomer
                    .filter(item => item.type_id === getValues("type_id").value)
                    .map(item => {
                      return {
                        ...item,
                        value: item.mst,
                        label: (item.mst ? item.mst + " | " : "") + item.ten,
                      };
                    }),
                  "auto",
                  () => {
                    const dataDetail = getValues("customer");
                    loadDataCustomer(dataDetail);
                  },
                  false,
                  loadListAllCustomer
                )}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup className="mb-3">
                {generateSelectField(
                  t("form.type_id"),
                  false,
                  errors,
                  "type_id",
                  t("placeholder.select", {
                    title: t("form.type_id"),
                  }),
                  false,
                  control,
                  LIST_TYPE_ID,
                  "auto",
                  () => {
                    setValue("customer", null);
                    loadDataCustomer(null);
                    // dispatch(getAllCustomerInvoice(getValues("type_id").value));
                  }
                )}
              </FormGroup>
            </Col>
          </Row>
          <hr></hr>
          <Label className="text-primary">Thông tin khách hàng :</Label>
          {watch("customer") ? (
            <Row className="row-cols-1 row-cols-lg-2">
              <Col>
                <FormGroup className="mb-3">
                  {generateInputField(
                    t("form.ma"),
                    false,
                    "text",
                    errors,
                    touchedFields,
                    "ma",
                    t("placeholder.enter", {
                      title: t("form.ma"),
                    }),
                    register,
                    true,
                    null,
                    control,
                    false,
                    false,
                    false,
                    null,
                    null,
                    true
                  )}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  {generateInputField(
                    t("form.ten"),
                    false,
                    "text",
                    errors,
                    touchedFields,
                    "ten",
                    t("placeholder.enter", {
                      title: t("form.ten"),
                    }),
                    register,
                    true
                  )}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  {generateInputField(
                    t("form.idno"),
                    false,
                    "text",
                    errors,
                    touchedFields,
                    "idno",
                    t("placeholder.enter", {
                      title: t("form.idno"),
                    }),
                    register,
                    true
                  )}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  {generateInputField(
                    t("form.mst"),
                    false,
                    "text",
                    errors,
                    touchedFields,
                    "mst",
                    "XXXXXXXXXX-XXX (10 hoặc 14 kí tự)",
                    register,
                    true,
                    null,
                    control,
                    false,
                    true
                  )}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  {generateInputField(
                    t("form.cty"),
                    false,
                    "text",
                    errors,
                    touchedFields,
                    "cty",
                    t("placeholder.enter", {
                      title: t("form.cty"),
                    }),
                    register,
                    true
                  )}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  {generateInputField(
                    t("form.stknhang"),
                    false,
                    "text",
                    errors,
                    touchedFields,
                    "stknhang",
                    t("placeholder.enter", {
                      title: t("form.stknhang"),
                    }),
                    register,
                    true
                  )}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  {generateInputField(
                    t("form.tnhang"),
                    false,
                    "text",
                    errors,
                    touchedFields,
                    "tnhang",
                    t("placeholder.enter", {
                      title: t("form.tnhang"),
                    }),
                    register,
                    true
                  )}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  {generateInputField(
                    t("form.dchi"),
                    false,
                    "text",
                    errors,
                    touchedFields,
                    "dchi",
                    t("placeholder.enter", {
                      title: t("form.dchi"),
                    }),
                    register,
                    true
                  )}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  {generateInputField(
                    t("form.sdthoai"),
                    false,
                    "text",
                    errors,
                    touchedFields,
                    "sdthoai",
                    t("placeholder.enter", {
                      title: t("form.sdthoai"),
                    }),
                    register,
                    true
                  )}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  {generateInputField(
                    t("form.dctdtu"),
                    false,
                    "text",
                    errors,
                    touchedFields,
                    "dctdtu",
                    t("placeholder.enter", {
                      title: t("form.dctdtu"),
                    }),
                    register,
                    true
                  )}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  {generateInputField(
                    t("form.fax"),
                    false,
                    "text",
                    errors,
                    touchedFields,
                    "fax",
                    t("placeholder.enter", {
                      title: t("form.fax"),
                    }),
                    register,
                    true
                  )}
                </FormGroup>
              </Col>
            </Row>
          ) : listAllCustomer.filter(
              item => item.type_id === getValues("type_id").value
            ).length > 0 ? (
            <div className="alert alert-primary" role="alert">
              <span className="pe-1">
                <i className="fas fa-exclamation-circle fa-lg"></i>
              </span>
              <span>Vui lòng chọn khách hàng</span>
            </div>
          ) : (
            <div className="alert alert-warning" role="alert">
              <span className="pe-1">
                <i className="fas fa-exclamation-circle fa-lg"></i>
              </span>
              <span>Không có thông tin</span>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="success"
            className="me-2 btn-label"
            disabled={!watch("customer")}
            onClick={handleSubmit(submitForm)}
          >
            <i className="bx bxs-info-circle label-icon" />
            Sử dụng
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

SearchCustomerModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  getInfoCustomerHandle: PropTypes.func,
  setValueFunc: PropTypes.func,
  mapData: PropTypes.object,
};

export default SearchCustomerModal;
